import { AntiFraudType } from './type'
import Visual from './Visual'

const AntiFraud = ({  }: AntiFraudType) => {
  return <Visual />
}

export default AntiFraud
